<template>
  <Modal :title="title" v-bind="$attrs" :value="$attrs.value" v-on="$listeners">
    <slot name="content" />
  </Modal>
</template>
<script>
import { Modal } from "ant-design-vue";

export default {
  components: {
    Modal
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
